import api from "@/api/api-v2-config";

export async function getEmailTemplateAxios() {    
    return await api.get("marketings/getemailtemplatelist?PageNumber=1&PageSize=10000");
}

export async function deleteEmailTemplateAxios(id) {    
    return await api.delete("marketings/deleteemailtemplate?id=" + id);
}

export async function postEmailTemplateAxios(item) {    
    return await api.post("marketings/createemailtemplate", item);
}

export async function putEmailTemplateAxios(item) {    
    return await api.put("marketings/updateemailtemplate", item);
}

export async function getEmailTemplateByIdAxios(id) {
    return await api.get("marketings/getemailtemplatebyid?id=" + id);
}

// platform type
export async function getPlatformTypeAxios() {
    return await api.get("marketingmanagements/getallplatformtype");
}

export async function postContentTemplateAXios(item){
    return await api.post("marketingmanagements/createcontenttemplate", item);
}

export async function getContentTemplateAxios() {
    return await api.get("marketingmanagements/getcontenttemplatelist");
}

export async function deleteContentTemplateAxios(id) {
    return await api.delete("marketingmanagements/deletecontenttemplate?id=" + id);
}

export async function getContentTemplateByIdAxios(id) {
    return await api.get("marketingmanagements/getcontenttemplatebyid?id=" + id);
}

export async function putContentTemplateAxios(id, item) {
    return await api.put(`marketingmanagements/updatecontenttemplate?id=${id}`, item);
}